import { PluginObject } from 'vue'
import LoadingApi from "./loading"

export const LoadingPlugin: PluginObject<any> = {
  install(Vue, options = {}) {
    Vue.prototype.$loading = LoadingApi(options)
  }
}

export default LoadingPlugin